// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { Orgao } from '../comum/orgao.model';

export class TipoImovelOcorrencia extends BaseResourceModel {
  constructor(
    public id?: number,
    public descricao?: string,
    public orgao?: Orgao,
  ) {
    super();
  }

  static converteJson(json: any): TipoImovelOcorrencia {
    return Object.assign(new TipoImovelOcorrencia(), json);
  }
}
